import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { appsAPI } from '../../services/api'

import { logger } from '@/utils/logger';
export default function AppsManagement() {
  const navigate = useNavigate()
  const [apps, setApps] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  useEffect(() => {
    loadApps()
  }, [])

  const loadApps = async () => {
    setLoading(true)
    try {
      const response = await appsAPI.getAll()
      setApps(response.data)
    } catch (err) {
      setError('Fehler beim Laden der Apps')
      logger.error('Error loading apps:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (app) => {
    if (!confirm(`Möchten Sie die App "${app.name}" wirklich löschen?`)) {
      return
    }

    try {
      await appsAPI.delete(app.id)
      setSuccess('App erfolgreich gelöscht')
      await loadApps()
      setTimeout(() => setSuccess(''), 3000)
    } catch (err) {
      setError(err.response?.data?.detail || 'Fehler beim Löschen der App')
      logger.error('Error deleting app:', err)
      setTimeout(() => setError(''), 3000)
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
        <div className="wc-spinner" />
      </div>
    )
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, margin: 0 }}>App-Verwaltung</h1>
        <button onClick={() => navigate('/admin/apps/new')} className="wc-btn wc-btn-primary">
          + Neue App
        </button>
      </div>

      {error && <div className="wc-alert wc-alert-error" style={{ marginBottom: 16 }}>{error}</div>}
      {success && <div className="wc-alert wc-alert-success" style={{ marginBottom: 16 }}>{success}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
        {apps.length === 0 ? (
          <div className="wc-muted" style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '48px 0' }}>
            Keine Apps vorhanden
          </div>
        ) : (
          apps.map((app) => (
            <div key={app.id} className="wc-card wc-elev-sm wc-card-hover" style={{ gap: 14 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                <div>
                  <h3 className="wc-card-title" style={{ margin: 0 }}>{app.name}</h3>
                  <p className="wc-muted" style={{ fontSize: 12, margin: '2px 0 0' }}>{app.slug}</p>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  {app.is_featured && <span className="wc-tag wc-tag-outline">Featured</span>}
                  <span className={`wc-tag ${app.is_active ? 'wc-tag-accent' : 'wc-tag-neutral'}`}>
                    {app.is_active ? 'Aktiv' : 'Inaktiv'}
                  </span>
                </div>
              </div>

              {app.short_description && (
                <p className="wc-card-body" style={{ margin: 0 }}>{app.short_description}</p>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className="wc-muted">Monatlich:</span>
                  <span>{app.price_monthly}€</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className="wc-muted">Jährlich:</span>
                  <span>{app.price_yearly}€</span>
                </div>
              </div>

              <div style={{ paddingTop: 12, borderTop: '1px solid var(--wc-divider)' }}>
                <span className="wc-muted" style={{ fontSize: 12 }}>Reihenfolge: {app.order_index}</span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 8 }}>
                  <button
                    onClick={() => navigate(`/admin/apps/${app.id}/plans`)}
                    className="wc-btn wc-btn-ghost"
                    style={{ padding: '4px 8px', fontSize: 12 }}
                  >
                    Pläne
                  </button>
                  <button
                    onClick={() => navigate(`/admin/apps/${app.id}/system-settings`)}
                    className="wc-btn wc-btn-ghost"
                    style={{ padding: '4px 8px', fontSize: 12 }}
                  >
                    System-Einstellungen
                  </button>
                  <button
                    onClick={() => navigate(`/admin/apps/${app.id}/edit`)}
                    className="wc-btn wc-btn-ghost"
                    style={{ padding: '4px 8px', fontSize: 12 }}
                  >
                    Bearbeiten
                  </button>
                  <button
                    onClick={() => handleDelete(app)}
                    className="wc-btn wc-btn-ghost"
                    style={{ padding: '4px 8px', fontSize: 12, color: '#fca5a5' }}
                  >
                    Löschen
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
